import { Flex } from 'antd'
import Image from '@/components/image'
import imageChoose from '@/assets/img/solution/school-bus/choose.png'
import Styles from './style.module.scss'

const TITLE = 'Why Choose Carus'
const data = [
  {
    title: 'Modular Distributed Energy Storage System',
    description: 'Distributed ESS (60 kWh-1.3 MWh) with modular scalability',
  },
  {
    title: 'Intelligent Energy Management Platform (EMS)',
    description:
      'Provides remote monitoring and system optimization functions to ensure efficient and stable operation',
  },
  {
    title: 'End-to-end Full-cycle Services',
    description:
      'Offers comprehensive support covering project design, engineering construction, and long-term operation & maintenance',
  },
  {
    title: 'Flexible Investment Models',
    description:
      'Supports multiple cooperation schemes such as direct investment, equipment leasing, and "turnkey" projects',
  },
]

export default function Advantage() {
  return (
    <Flex vertical align='center' className={Styles.advantage}>
      <h2>{TITLE}</h2>
      <Image src={imageChoose} alt='choose' rootClassName={Styles.image} />
      <Flex className={Styles.content}>
        {data.map((item, index) => (
          <Flex vertical key={index} className={Styles.item}>
            <div className={Styles.title}>{item.title}</div>
            <div className={Styles.description}>{item.description}</div>
          </Flex>
        ))}
      </Flex>
    </Flex>
  )
}
